import ReactGa from 'react-ga'

const InitializeReactGa =() => {
    ReactGa.initialize('UA-162709555-1');
}

export default InitializeReactGa;